import React from 'react';
export function Solution() {
  return <section className="py-16 md:py-24 px-4 bg-[#FDFBF9]" data-id="element-200">
      <div className="max-w-5xl mx-auto" data-id="element-201">
        <div className="text-center mb-12 md:mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E2E2E] mb-4" data-id="element-203">
            El Sistema 3 Síes
          </h2>
          <p className="text-lg md:text-xl text-[#2E2E2E]/70" data-id="element-204">
            Base + Puente + Autonomía
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-12" data-id="element-205">
          {/* Base */}
          <div className="bg-white p-6 md:p-8 rounded-xl border border-[#2E2E2E]/5 shadow-sm" data-id="element-206">
            <div className="w-12 h-12 bg-[#0D3B66] text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-207">
              1
            </div>
            <h3 className="text-xl font-bold text-[#2E2E2E] mb-3" data-id="element-208">Base</h3>
            <p className="text-[#2E2E2E]/70 leading-relaxed" data-id="element-209">
              Lo familiar. Algo que ya conocen y aceptan sin resistencia. El
              punto de partida seguro.
            </p>
          </div>

          {/* Puente */}
          <div className="bg-white p-6 md:p-8 rounded-xl border border-[#2E2E2E]/5 shadow-sm" data-id="element-210">
            <div className="w-12 h-12 bg-[#E0435A] text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-211">
              2
            </div>
            <h3 className="text-xl font-bold text-[#2E2E2E] mb-3" data-id="element-212">Puente</h3>
            <p className="text-[#2E2E2E]/70 leading-relaxed" data-id="element-213">
              Salsa, topping o formato que vuelve "amigable" lo que antes
              rechazaban. El conector.
            </p>
          </div>

          {/* Autonomía */}
          <div className="bg-white p-6 md:p-8 rounded-xl border border-[#2E2E2E]/5 shadow-sm" data-id="element-214">
            <div className="w-12 h-12 bg-[#2E2E2E] text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-215">
              3
            </div>
            <h3 className="text-xl font-bold text-[#2E2E2E] mb-3" data-id="element-216">Autonomía</h3>
            <p className="text-[#2E2E2E]/70 leading-relaxed" data-id="element-217">
              2 opciones cerradas para que el niño sienta control sin manejar la
              cocina.
            </p>
          </div>
        </div>

        {/* Ejemplo práctico */}
        <div className="bg-[#F6EEDC] rounded-xl p-6 md:p-8 max-w-2xl mx-auto" data-id="element-218">
          <p className="text-sm font-semibold text-[#0D3B66] uppercase tracking-wide mb-3" data-id="element-219">
            Ejemplo práctico
          </p>
          <div className="space-y-2 text-[#2E2E2E]" data-id="element-220">
            <p data-id="element-221">
              <strong data-id="element-222">Base:</strong> Fideos (lo que ya comen sin drama)
            </p>
            <p data-id="element-223">
              <strong data-id="element-224">Puente:</strong> Salsa de calabaza "naranja" (verdura
              camuflada)
            </p>
            <p data-id="element-225">
              <strong data-id="element-226">Autonomía:</strong> "¿Querés queso rallado o queso en
              cubitos?"
            </p>
          </div>
        </div>
      </div>
    </section>;
}